// Einladungslink: /einladung/<token>
//
// Die Seite selbst tut fast nichts. Sie reicht den Token an den Anmeldeweg
// weiter, der ihn in den Zwischenstand des Logins legt; eingeloest wird er
// erst beim Ruecksprung von Google, wenn feststeht, wer da eigentlich kommt.
// Deshalb steht der Token hier auch nur in der Adresse und nirgendwo sonst.

import { useParams } from "react-router-dom";
import { Karte, Rahmen } from "../bausteine/Bausteine.js";

export function Einladung() {
  const { token } = useParams<{ token: string }>();

  return (
    <Rahmen
      kinder={
        <Karte
          kinder={
            <>
              <h2 className="mb-1 text-base font-medium">Du bist eingeladen</h2>
              <p className="mb-4 text-sm text-neutral-600">
                Melde dich mit deinem Google-Konto an. Dank der Einladung ist dein Konto sofort
                nutzbar, ohne Warten auf die Freischaltung.
              </p>
              <a
                href={`/api/auth/google?einladung=${encodeURIComponent(token ?? "")}`}
                className="inline-flex min-h-11 items-center rounded bg-akzent px-4 py-2 text-sm font-medium text-white transition hover:bg-akzent-dunkel"
              >
                Mit Google anmelden
              </a>
            </>
          }
        />
      }
    />
  );
}
